import "./Mang.css";
const Mang = () => {
  return (
   <>
    <div class="box">

        <div class="eye-box left-eye">
            <div class="eye circle  sharingan1to2">
                <div class="eye-ball center">
                      <div class="circle"></div>
                      <div class="circle center"></div>
                      <div class="sp"><span class="center">,</span></div>
                      <div class="sp"><span class="center">,</span></div>
                      <div class="sp"><span class="center">,</span></div>
                </div>
            </div>
        </div>
        <div class="eye-box ">
            <div class="eye circle  sharingan1to2">
                <div class="eye-ball center">
                      <div class="circle"></div>
                      <div class="circle center"></div>
                      <div class="sp"><span class="center">,</span></div>
                      <div class="sp"><span class="center">,</span></div>
                      <div class="sp"><span class="center">,</span></div>
                </div>
            </div>
        </div>
        
    </div>

    
    

  </>
  );
};
export default Mang;
